import { setIn } from '@/scopes/common/domain/functions/objectDeepOperations'
import { PropertyIn, PropertyPath } from '@/scopes/common/domain/types'
import { createStore } from 'zustand/vanilla'

export interface QueueState {
  isFetched: boolean
  waitingTime: number | null
  fetchingError: boolean
}

const defaultInitialState: QueueState = {
  isFetched: false,
  waitingTime: null,
  fetchingError: false,
}

export interface QueueActions {
  initialize: (state: QueueState) => void
  setIn: <K extends PropertyPath<QueueState>>(
    path: K,
    value: PropertyIn<QueueState, K>
  ) => void
}

export type QueueStore = QueueState & QueueActions

export const queueStore = createQueueStore()

export function createQueueStore(initialState: QueueState = defaultInitialState) {
  return createStore<QueueStore>(set => ({
    ...initialState,
    initialize: (state: QueueState) => {
      set(() => state)
    },
    setIn: (path, value) => {
      set(state => setIn(state, path, value))
    },
  }))
}
